import { z } from 'zod'

export const workWvsFacadeResponseSchema = z.object({}).passthrough()
export type WorkWvsFacadeResponse = z.infer<typeof workWvsFacadeResponseSchema>
